// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"ad9a1d7a","336":"99ee7b0e","592":"f3e5d88c","684":"19cdd4f8","944":"99fb4fba"}[chunkId] + ".chunk.js";
};